import {Component, Input, output} from '@angular/core';
import {Publication} from "../../../models/publication.model";
import {
  RdsIconComponent,
} from "@rds/angular-components";
import {DetailedViewObjectService} from "../../../services/detailed-view-object.service";
import {ContextMenuService} from "../../../services/context-menu.service";
import {DataObject, STATUS_COLOR_MAP} from "../../../models/metadata";

import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-publication',
  standalone: true,
  imports: [
    RdsIconComponent
],
  templateUrl: './publication.component.html',
  styleUrl: './publication.component.scss'
})
export class PublicationComponent {
  @Input() publication!: Publication
  deletePublication = output<DataObject>()
  isViewer: boolean = true;
  
  constructor(
    private detailedObjectService: DetailedViewObjectService,
    private contextMenuService: ContextMenuService,
    private userService: UserService
  ) {
    this.userService.getUserData().then(user => {
      this.isViewer = user.isViewer;
    });
  }
  
  onCardClick(){
    this.detailedObjectService.nextDetailedObject(this.publication)
  }

  // Not implementing context menu for publications yet
  // Will need to add publication to MenuSource type in ContextMenuService first
  onContextMenu(_: MouseEvent){
    // For now, not using context menu
  }

  getStudiesWithName(){
    return this.publication.metadata.studies.filter(s => !!s.studyName)
  }

  get displayTarget(): string {
    return this.publication.metadata.congress_acronym || this.publication.metadata.target;
  }

  get targetTooltip(): string {
    return this.publication.metadata.congress_acronym ? this.publication.metadata.target : this.publication.metadata.target;
  }

  get displayTitle(): string {
    return this.publication.metadata.shortTitle || this.publication.metadata.title;
  }

  get titleTooltip(): string {
    return this.publication.metadata.shortTitle ? this.publication.metadata.title : this.publication.metadata.title;
  }

  protected readonly STATUS_COLOR_MAP = STATUS_COLOR_MAP;

  // Contrast helper duplicated from admin tables
  getContrastColor(hexColor?: string | null): string {
    const hex = (hexColor || '').replace('#','');
    if (hex.length !== 6) {
      return '#111827';
    }
    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2,4), 16);
    const b = parseInt(hex.substring(4,6), 16);
    const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
    return luminance > 0.6 ? '#111827' : '#FFFFFF';
  }
}
